///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit = modules.ribit || {};
modules.ribit.reporting = modules.ribit.reporting || {};
modules.ribit.reporting.common = modules.ribit.reporting.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
modules.ribit.reporting.common = {
    report_id: null,
    columns: [],
    periods: [],
    rollup_columns: [],
    current_field: null,
    current_val: [],

    /**
     *
     */
    init: function () {
        // Validate the query builder form before submitting
        $(document).on("submit", "body.ribit.reporting form", function(e) {
            $('#builder-div').queryBuilder('validate');

            if ($('#builder-div .has-error').length > 0) {
                e.preventDefault();

                // Mark the filters tab invalid
                ri_form_wizard.markTabInvalid(2);

                // Switch to the filters tab
                ri_form_wizard.selectItemFormTab(2);

                setTimeout(function() {
                    alert('Please correct any filters that are highlighted in red before submitting the form');
                }, 100);

                return false;
            }
        });

        // Add a new period button clicked
        $(document).on('click', '#btn_add_period', function(e) {
            let period_display = $('#modules_r_i_b_i_t_entities_adhoc_report_period_id_period_id_period_id option:selected').text();
            let period_id = $('#modules_r_i_b_i_t_entities_adhoc_report_period_id_period_id_period_id').val();

            // Custom range selected
            if (period_id == 0) {
                if (!$('#modules_r_i_b_i_t_entities_adhoc_report_date_range_date_range_date_range').val()) {
                    return false;
                }

                period_id = $('#modules_r_i_b_i_t_entities_adhoc_report_date_range_date_range_date_range').val();
                period_display = $('#modules_r_i_b_i_t_entities_adhoc_report_date_range_date_range_date_range').val();
            }

            const value = JSON.stringify({
                id: period_id,
                text: period_display,
                period_on_period: $('#period_on_period').val() != '' ? $('#period_on_period').val() : null,
            });

            modules.ribit.reporting.common.periods = $('#periods').val() ? JSON.parse($('#periods').val()) : [];

            // Prevent duplicate periods/ranges
            if (modules.ribit.reporting.common.periods.find(p => p.id == period_id)) {
                alert('The selected period has already been added');
                return false;
            }

            $(this).addClass('disabled');
            $('#period_on_period').val('');

            modules.ribit.reporting.common.periods.push(JSON.parse(value));
            $('#periods').val(JSON.stringify(modules.ribit.reporting.common.periods));
            document.getElementById("periods").dispatchEvent(new Event('input'));
        });

        // Remove Column Button clicked
        $(document).on('click', '.btn-remove-period', function(e) {
            $(this).closest('li').remove();
            modules.ribit.reporting.common.updatePeriods(true);
        });

        // Rollup Button clicked
        $(document).on('click', '.btn-rollup-column', function(e) {
            $(this).closest('li').data('use_rollup', !$(this).closest('li').data('use_rollup'));

            // Format the column ui widgets and update the hidden columns field
            modules.ribit.reporting.common.updateColumns();
        });

        // Remove Column Button clicked
        $(document).on('click', '.btn-remove-column', function(e) {
            const listItem = $(this).closest('li').remove();

            $('.field-row.columns .list-group.left ul.group[data-optgroup="' + listItem.data('optgroup') + '"]')
                .append(listItem)
                .show()
                .parent().find('i').removeClass('fa-square-plus').addClass('fa-square-minus');

            // Format the column ui widgets and update the hidden columns field
            modules.ribit.reporting.common.updateColumns();
        });

        // The column search field had a key pressed
        $(document).on('keyup', 'body.ribit.reporting #column-search', function () {
            const value = $(this).val().toLowerCase();

            if (value) {
                // Filter down the groups + columns to what was typed
                $('.list-group.left li:not(.group-parent)').each(function() {
                    const show = $(this).text().toLowerCase().indexOf(value) > -1;
                    $(this).toggleClass('filtered', !show);
                });

                // Expand or collapse any sub-sections
                $('.list-group.left li.group-parent').each(function() {
                    const show = $(this).find('ul.group li:not(.filtered)').length > 0;
                    $(this).toggle(show).find('ul.group').toggle(show);
                    $(this).find('i').toggleClass('fa-square-minus', show).toggleClass('fa-square-plus', !show);
                });

            } else {
                // Clear search results and show all columns
                $('.list-group.left li').removeClass('filtered').show();
                $('.list-group.left ul.group').hide();
                $('.list-group.left li.group-parent i').removeClass('fa-square-minus').addClass('fa-square-plus');

                modules.ribit.reporting.common.updateColumns();
            }
        });

        // LivewireFieldCollection event listener
        Livewire.on('fieldsRendered', fields => {
            let report = null;

            // Find the selected ReportTable
            $.each(fields, function(i, v) {
                if (v.column == "report_table_id") {
                    report = v.value;
                }
            });

            // Initialize the periods widget
            this.initPeriods();

            // Apply the daterangepicker to the date_range input
            this.initDateRangePicker();

            // Initialize the column widget logic
            this.initColumnWidget();

            // Initialize the query builder filters
            this.initFilters(report);
        });

        // Initialize the filter modal logic
        this.initFilterModal();

        // Initialize the periods widget
        this.initPeriods();

        // Apply the daterangepicker to the date_range input
        this.initDateRangePicker();

        // Initialize the column widget logic
        this.initColumnWidget();

        // Initialize the query builder filters when editting a report
        this.initFilters($('input[name=report_table_id_report_table_id]:checked').val());
    },

    /**
     * Initialize the periods widget
     */
    initPeriods: function () {
        $('.field-row.periods .list-group ul.group').ribitSortable('destroy');

        $('.field-row.periods .list-group ul.group').ribitSortable({
            forcePlaceholderSize: true,
            handle: 'i.fa-bars',
            placeholderClass: 'placeholder',
        }).bind('sortupdate', function(e, ui) {
            // Update the hidden periods field
            modules.ribit.reporting.common.updatePeriods(true);
        });

        // Update the hidden periods field
        this.updatePeriods();
    },

    /**
     * Update the hidden periods field
     */
    updatePeriods: function (trigger = false) {
        let periods = [];

        $('.field-row.periods .list-group').find('li').each(function() {
            periods.push(JSON.parse(JSON.stringify($(this).data('value'))));
        });

        $('#periods').val(periods.length ? JSON.stringify(periods) : '');

        if (trigger) {
            // Trigger a browser event to trigger a livewire model update
            document.getElementById("periods").dispatchEvent(new Event('input'));
        }
    },

    /**
     * Initialize the filter modal logic
     */
    initFilterModal: function () {
        // Handle when the view all filter modal is shown
        $('#filter-modal').on('show.bs.modal', function (e) {
            // Set the modal header
            $('#filter-modal .modal-title').text('View All: ' + $(e.relatedTarget).data('label'));

            // Show a loading spinner
            $('#filter-modal .modal-body').html('<div class="text-center"><i class="fa fa-spinner fa-spin fa-2x"></i></div>');

            // Close all select2 dropdowns when the "view all" modal is opening
            $('.form-control.select2-hidden-accessible').select2("close");

            // Track the select2 dropdown
            modules.ribit.reporting.common.current_field = $('select[data-select2-id="' + $(e.relatedTarget).data('field') + '"]');
            modules.ribit.reporting.common.current_val = modules.ribit.reporting.common.current_field.val();

            // Load the filter values in a "View All" table
            $.get('/truvu/reporting/table/' + modules.ribit.reporting.common.report_id + '/' + $(e.relatedTarget).data('column') + '?label=' + $(e.relatedTarget).data('label'), function(data) {
                $('#filter-modal .modal-body').html(data);
            });
        });

        // Toggle the value to/from the query builder when a filter value is selected
        $(document).on('click', '#filter-modal .toggle-value', function(e) {
            // Add/Remove the value to/from the select2 dropdown when a filter value is selected from the popup modal
            modules.ribit.reporting.common.toggleModalValue($(this));
        });

        // Toggle all visible checkboxes in the filter modal
        $(document).on('click', '#filter-modal .select_all', function(e) {
            e.stopPropagation();
            // e.preventDefault();

            $('#filter-modal .toggle-value').prop('checked', $(this).is(':checked')).each(function() {
                modules.ribit.reporting.common.toggleModalValue($(this));
            });
        });
    },

    /**
     * Apply the daterangepicker to the date_range input
     */
    initDateRangePicker: function () {
        $('input.date_range').daterangepicker({
            alwaysShowCalendars: true,
            minDate: moment().subtract(5, 'years'),
            maxDate: moment(),
            "cancelClass": "btn-secondary",
            showDropdowns: true,
            locale: {
                format: 'MM/DD/YYYY',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
        });
    },

    /**
     * Initialize the column widget logic
     */
    initColumnWidget: function () {
        $('label.group-toggler').off('click').click(function () {
            $(this).parent().children('ul.group').slideToggle(300);
            $(this).find('i').toggleClass('fa-square-minus fa-square-plus');
        });

        $('.field-row.columns .list-group.right, .field-row.columns ul.group').ribitSortable('destroy');

        $('.field-row.columns .list-group.right, .field-row.columns ul.group').ribitSortable({
            forcePlaceholderSize: true,
            handle: 'i.fa-bars',
            placeholderClass: 'placeholder',
            connectWith: ".list-group.right"
        }).bind('sortupdate', function(e, ui) {
            // Format the column ui widgets and update the hidden columns field
            modules.ribit.reporting.common.updateColumns();
        }).bind('sortconnect', function(e, ui) {
            // Format the column ui widgets and update the hidden columns field
            modules.ribit.reporting.common.updateColumns();
        });

        // Format the column ui widgets and update the hidden columns field
        this.updateColumns();
    },

    /**
     * Format the column ui widgets and update the hidden columns field
     */
    updateColumns: function () {
        // Show/hide groups headers on the left column
        $('.field-row.columns .list-group.left label.group-toggler').each(function() {
            if (!$('.field-row.columns .list-group.left li[data-optgroup="' + $(this).text().trim() + '"]').length) {
                $(this).parent().hide();
            } else {
                $(this).parent().show();
            }
        });

        // Add or remove badges, buttons and rollups on the list item for the optgroup/headers
        $('.field-row.columns .list-group.right li:not(.group-parent)').each(function() {
            const buttons = '<span class="badge bg-primary text-white ms-2 ml-2">' + $(this).data('optgroup') + '</span>' +
                  '<button type="button" class="btn btn-outline-danger border-0 btn-sm btn-remove-column"><i class="fa fa-trash"></i>';

            // Add rollup checkbox to the column if it is rollup-able
            const active = $(this).data('use_rollup') ? 'active' : '';
            const rollup = $(this).data('rollup')
                ? '<button type="button" class="btn btn-outline-info border-0 btn-sm btn-rollup-column ' + active + '" title="Rollup on Column"><i class="fa-solid fa-list-check"></i>'
                : '';

            $(this).html('<i class="fa fa-bars me-2 mr-2"></i>' + $(this).data('text') + '<span class="ms-auto ml-auto">' + rollup + buttons + '</span>');
        });

        // Update the hidden columns field
        $('#columns option, #rollup_columns option').remove();

        $('.field-row.columns .list-group.right').find('li').each(function() {
            // Add the selected columns to the hidden field
            $('#columns').append($('<option>', {
                value: $(this).data('value'),
                text: $(this).data('value'),
                selected: 'selected'
            }));

            // Add the rollup columns to the hidden field
            if ($(this).data('use_rollup')) {
                $('#rollup_columns').append($('<option>', {
                    value: $(this).data('value'),
                    text: $(this).data('value'),
                    selected: 'selected'
                }));
            }
        });

        // Trigger a browser event to trigger a livewire model update
        if ($('#columns').length && modules.ribit.reporting.common.columns != $('#columns').val().toString()) {
            modules.ribit.reporting.common.columns = $('#columns').val().toString();
            document.getElementById("columns").dispatchEvent(new Event('change'));
        }

        // Trigger a browser event to trigger a livewire model update
        if ($('#rollup_columns').length && modules.ribit.reporting.common.rollup_columns != $('#rollup_columns').val().toString()) {
            modules.ribit.reporting.common.rollup_columns = $('#rollup_columns').val().toString();
            document.getElementById("rollup_columns").dispatchEvent(new Event('change'));
        }
    },

    /**
     * Initialize the query builder filters
     */
    initFilters: function (report) {
        if (report && modules.ribit.reporting.common.report_id != report) {
            modules.ribit.reporting.common.report_id = report;

            $('#builder-div').queryBuilder('destroy');

            $('#builder-div').on('afterCreateRuleFilters.queryBuilder', function(e, rule) {
                // Format the query builder buttons
                $('#builder-div .group-conditions .btn-xs').addClass('btn-outline-primary').removeClass('btn-primary');
                $('#builder-div .pull-right').addClass('float-end float-right');
                $('#builder-div select.form-control').addClass('form-select');
                $('#builder-div i.glyphicon.glyphicon-plus-sign').removeClass('glyphicon glyphicon-plus-sign').addClass('fa-solid fa-plus fa-xs');
                $('#builder-div i.glyphicon.glyphicon-remove').parent().html('<i class="fa-solid fa-trash fa-fw"></i>').addClass('me-2 mr-2');
            });

            $('#builder-div').on('afterUpdateRuleValue.queryBuilder', function(e, rule) {
                // Apply the form-select class to the select dropdown for BS5 support
                $('#builder-div select.form-control').addClass('form-select');

                // Remove any existing plugin buttons
                rule.$el.find('.rule-header .btn-group .plugin-btn').remove();

                // Format the Bootstrap Datepicker plugin
                if (rule.filter.plugin === 'datepicker') {
                    modules.ribit.reporting.plugins.datepicker.initRule(rule);
                }

                // Format the Select2 plugin
                if (rule.filter.plugin == 'select2') {
                    modules.ribit.reporting.plugins.select2.initRule(rule);
                }
            });

            $('#builder-div').on('validationError.queryBuilder', function(e, rule, error, value) {
                // Display the error message in the query builder
                const errorMsg = $(rule.$el).find('.error-container').attr('title');

                if (!$(rule.$el).find('.rule-error-msg').length && errorMsg) {
                    rule.$el.find('.rule-operator-container').after('<div class="rule-error-msg row px-2"><div class="col"><i class="fa-solid fa-triangle-exclamation text-danger me-2 mr-2"></i>' + errorMsg + '</div></div>');
                }
            });

            // Use a query builder event to handle this (this is to update the preview in real time)
            setInterval(() => {
                $('#builder-div .rule-error-msg').remove();
                const filters = JSON.stringify($('#builder-div').queryBuilder('getRules'));

                if ($('#filters').val() != filters && $('#builder-div .has-error').length === 0) {
                    $('#filters').val(filters);

                    // Trigger a browser event to trigger a livewire model update
                    document.getElementById("filters").dispatchEvent(new Event('input'));
                }
            }, 250);

            let filters = JSON.parse($('#filter_columns').val());

            $(filters).each(function(i, v) {
                // Add custom select2 plugin configuration - https://querybuilder.js.org/demo.html#widgets
                if (v.plugin == 'select2') {
                    modules.ribit.reporting.plugins.select2.initPlugin(v);
                }
            });

            // Instantiate the query builder
            $('#builder-div').queryBuilder({
                filters: filters,
                allow_empty: true,
                select_placeholder: '',
                rules: $('#filters').val() ? JSON.parse($('#filters').val()) : [],
                // rules: $('#filters').val() ? JSON.parse($('#filters').val()) : null,
                optgroups: $('#opt_groups').val() ? JSON.parse($('#opt_groups').val()) : null,
            });
        }
    },

    /**
     * Add/Remove the value to/from the select2 dropdown when a filter value is selected from the popup modal
     *
     * @param {*} btn
     */
    toggleModalValue: function (btn) {
        const field = modules.ribit.reporting.common.current_field;

        if (btn.is(':checked')) {
            // Add the value to the select2 dropdown if it doesn't exist
            if (!field.find('option[value="' + btn.data('value') + '"]').length) {
                field.append($('<option>').text(btn.data('value')).val(btn.data('value')));
            }

            modules.ribit.reporting.common.current_val.push(btn.data('value'));
        } else {
            // Remove the value from the array
            modules.ribit.reporting.common.current_val = modules.ribit.reporting.common.current_val.filter(function(item) {
                return item !== btn.data('value');
            });
        }

        field.val(modules.ribit.reporting.common.current_val).trigger("change");
    },
};
